import React from "react";
import { Link } from "react-router-dom";
import OTMHeader from "../layout/OTMHeader";
import Title from "../layout/Title";
import {
  EnvelopeIcon,
  DocumentDuplicateIcon,
  MegaphoneIcon,
} from "@heroicons/react/24/outline";

export default function Decision() {
  return (
    <>
      <OTMHeader />
      <Title title="Select an option" settingsButton={false} />
      <div className="flex justify-center mt-6 mb-6 lg:mt-16">
        <div className="flex flex-col lg:flex-row lg:space-x-24 space-y-8 lg:space-y-0">
          <a
            href="https://onetrustmarketing.com/lxercmbowpozmwbdgxky/"
            className="flex flex-col items-center justify-center transition transform hover:scale-105"
          >
            <EnvelopeIcon className="w-20 h-20 mb-4 transition rounded-md text-white p-3 bg-blue-complimentary transform hover:scale-110" />
            <h1 className="text-xl font-bold text-blue-primary text-center transition-colors hover:text-green-primary">
              Email Campaigns
            </h1>
          </a>
          <Link
            to="/"
            className="flex flex-col items-center justify-center transition transform hover:scale-105"
          >
            <DocumentDuplicateIcon className="w-20 h-20 mb-4 transition rounded-md text-white p-3 bg-blue-complimentary transform hover:scale-110" />
            <h1 className="text-xl font-bold text-blue-primary text-center transition-colors hover:text-green-primary">
              Flyer Generator
            </h1>
          </Link>
          <a
            href="https://onetrustmarketing.com/social-media/"
            className="flex flex-col items-center justify-center transition transform hover:scale-105"
          >
            <MegaphoneIcon className="w-20 h-20 mb-4 transition rounded-md text-white p-3 bg-blue-complimentary transform hover:scale-110" />
            <h1 className="text-xl font-bold text-blue-primary text-center transition-colors hover:text-green-primary">
              Social Media
            </h1>
          </a>
        </div>
      </div>
    </>
  );
}
